export enum CaseSolutionType {
    Common,
    Board,
    SocialMedia,
    C3_R1
}
